// styling
import styles from './style.module.scss';
// components
import Spring from '@components/Spring';
// assets
import shape from '@assets/about/shape.svg';
import classNames from 'classnames';
import GradientBtn from '@ui/GradientBtn';

const ThePlatform = () => {
    const data = [
        { label: '1. Uniquely Designed AI Model', info: 'We’re developing a customized ML model for text-to-image and image-to-image capabilities that will translate into visual content.' },
        { label: '2. Creator Control', info: 'Users can select from 3 art formats (Comics, Manga, & Webcomics) in addition to various artistic styles associated with each format.' },
        { label: '3. Ownership Of Intellectual Property', info: 'Creators will maintain full IP ownership of the content created. UE COMIX™ will never claim any rights towards the visual works created through the platform.' },
        { label: '4. Reducing Barriers Towards Creation', info: 'Creators can develop, create, and share their projects at an affordable rate without dependency on a team or drawing abilities.' },
    ];

    return (
        <section className={styles.section}>
            <img className={styles.shape} src={shape} alt="media" />
            <div className={`${styles.container} container`}>
                <div className="d-flex flex-column g-10">
                    <p className={styles.pPlat}>THE PLATFORM</p>
                    <p className={styles.pPlatText}>
                        Using <span className={styles.pPlatTextSpan}>Artificial
                            Intelligence</span> To Create
                        Sequential Artworks!
                    </p>
                </div>
                <div className={styles.main}>
                    {
                        data.map((item, index) => (
                            <Spring key={index} index={index}>
                                <div className={`${styles.main_item} d-flex flex-column g-10 border-10 bg-secondary`}>
                                    <p className={classNames('h6', styles.label)}>{item.label}</p>
                                    <p className={styles.dataInfo}>{item.info}</p>
                                </div>
                            </Spring>
                        ))
                    }
                </div>

                <GradientBtn className={styles.button} href="/about">
                    About Us
                </GradientBtn>

            </div>
        </section>
    )
}

export default ThePlatform